import { createSlice } from '@reduxjs/toolkit'

export const StakesSlice = createSlice({
  name: 'Stakes',
  initialState: [100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 25000],
  reducers: {
    getStakesSuccess: (state, action) => action.payload,
    getStakesError: (state) => state,
  },
})

export const { getStakesSuccess, getStakesError } = StakesSlice.actions

export default StakesSlice.reducer
